import { useEffect, useState } from "react";

export const PdfFrame = ({ data, title, className }) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!data) return;
    const b64 = data.includes(",") ? data.split(",")[1] : data;
    const bin = atob(b64);
    const bytes = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    const u = URL.createObjectURL(new Blob([bytes], { type: "application/pdf" }));
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [data]);
  if (!url) return <div className={className} data-testid="pdf-preview-loading" />;
  return <iframe title={title} src={url} className={className} data-testid="pdf-preview-frame" />;
};
